export class HomeKpi {

  public static fromJson(json: Object): HomeKpi {
    const o: HomeKpi = new HomeKpi();

    o.id = json['id'];
    o.title = json['title'];
    o.homeKpiType = json['homeKpiType'];
    o.colors = json['colors'];
    o.labels = json['labels'];
    o.values = json['values'];

    o.showTitle = json['showTitle'];
    o.showLabels = json['showLabels'];
    o.showLegends = json['showLegends'];

    o.xs = json['xs'];
    o.sm = json['sm'];
    o.md = json['md'];
    o.lg = json['lg'];

    o.height = json['height'];
    o.width = json['width'];

    return o;
  }

  public id : string;
  public title : string;
  public homeKpiType : string;
  public colors : string[];
  public labels : string[];
  public values : any[];

  public showTitle : boolean;
  public showLabels : boolean;
  public showLegends : boolean;

  public sm : number;
  public xs : number;
  public md : number;
  public lg : number;

  public height : string;
  public width : string;


}



// WEBPACK FOOTER //
// ./src/model/HomeKpi.ts